
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/roster/jst/rosterUser';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n  <td class=\"center\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isStudent), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </td>\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <input type=\"checkbox\" class=\"select-user-checkbox\" id=\"select-user-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n    aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "select_name_fc77efbd", "Select %{name}", options) : helperMissing.call(depth0, "t", "select_name_fc77efbd", "Select %{name}", options)))
    + "\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isSelected), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " />\n    ";
  return buffer;
  }
function program3(depth0,data) {
  
  
  return "checked";
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += " <i>(";
  if (helper = helpers.pronouns) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.pronouns); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + ")</i>";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += " <a id=\"tag-icon-id-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" href=\"#\" class=\"user-tags-icon\" role=\"button\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "view_name_user_tags_6e8306e3", "View %{name} user tags", options) : helperMissing.call(depth0, "t", "view_name_user_tags_6e8306e3", "View %{name} user tags", options)))
    + "\"><i class=\"icon-tag\"></i></a> ";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "<span class=\"label label-info\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "courses.roster.roster_user.pending_acceptance_explanation", "This user has not yet accepted the invitation to the course", options) : helperMissing.call(depth0, "t", "courses.roster.roster_user.pending_acceptance_explanation", "This user has not yet accepted the invitation to the course", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "courses.roster.roster_user.pending_acceptance_of_invitation", "pending", options) : helperMissing.call(depth0, "t", "courses.roster.roster_user.pending_acceptance_of_invitation", "pending", options)))
    + "<span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "courses.roster.roster_user.pending_acceptance_explanation", "This user has not yet accepted the invitation to the course", options) : helperMissing.call(depth0, "t", "courses.roster.roster_user.pending_acceptance_explanation", "This user has not yet accepted the invitation to the course", options)))
    + "</span></span>";
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "<span class=\"label\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "this_user_is_currently_not_able_to_access_the_cour_39cabed1", "This user is currently not able to access the course", options) : helperMissing.call(depth0, "t", "this_user_is_currently_not_able_to_access_the_cour_39cabed1", "This user is currently not able to access the course", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "inactive_cd40317f", "inactive", options) : helperMissing.call(depth0, "t", "inactive_cd40317f", "inactive", options)))
    + "<span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "this_user_is_currently_not_able_to_access_the_cour_39cabed1", "This user is currently not able to access the course", options) : helperMissing.call(depth0, "t", "this_user_is_currently_not_able_to_access_the_cour_39cabed1", "This user is currently not able to access the course", options)))
    + "</span></span>";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "<span class=\"";
  if (helper = helpers.temporaryEnrollmentLabelClass) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.temporaryEnrollmentLabelClass); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "temporary_enrollment_status_5df96f90", "Temporary enrollment status", options) : helperMissing.call(depth0, "t", "temporary_enrollment_status_5df96f90", "Temporary enrollment status", options)))
    + "\">";
  if (helper = helpers.temporaryEnrollmentLabel) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.temporaryEnrollmentLabel); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "<span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "temporary_enrollment_status_5df96f90", "Temporary enrollment status", options) : helperMissing.call(depth0, "t", "temporary_enrollment_status_5df96f90", "Temporary enrollment status", options)))
    + "</span></span>";
  return buffer;
  }

function program15(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n<td>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canViewLoginId), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>\n";
  return buffer;
  }
function program16(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n  ";
  if (helper = helpers.login_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.login_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n  ";
  return buffer;
  }

function program18(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n<td>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canViewSisId), {hash:{},inverse:self.noop,fn:self.program(19, program19, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>\n";
  return buffer;
  }
function program19(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n  ";
  if (helper = helpers.sis_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.sis_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n  ";
  return buffer;
  }

function program21(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n<td data-testid=\"section-column-cell\">\n  ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.sections), {hash:{},inverse:self.noop,fn:self.program(22, program22, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>\n";
  return buffer;
  }
function program22(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n  <div class=\"section\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n  ";
  return buffer;
  }

function program24(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <div>\n    "
    + escapeExpression((helper = helpers.enrollmentName || (depth0 && depth0.enrollmentName),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.role), options) : helperMissing.call(depth0, "enrollmentName", (depth0 && depth0.role), options)))
    + "\n  </div>\n  ";
  return buffer;
  }

function program26(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n<td>\n  ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.enrollments), {hash:{},inverse:self.noop,fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>\n<td>\n  <div>";
  if (helper = helpers.total_activity_string) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.total_activity_string); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n</td>\n";
  return buffer;
  }
function program27(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <div "
    + escapeExpression((helper = helpers.contextSensitiveDatetimeTitle || (depth0 && depth0.contextSensitiveDatetimeTitle),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.last_activity_at), options) : helperMissing.call(depth0, "contextSensitiveDatetimeTitle", (depth0 && depth0.last_activity_at), options)))
    + ">\n    "
    + escapeExpression((helper = helpers.tEventToString || (depth0 && depth0.tEventToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.last_activity_at), "short", "tiny", options) : helperMissing.call(depth0, "tEventToString", (depth0 && depth0.last_activity_at), "short", "tiny", options)))
    + "\n  </div>\n  ";
  return buffer;
  }

function program29(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <div class=\"admin-links\">\n    <a role=\"button\" class=\"al-trigger al-trigger-gray\" href=\"javascript:void(0)\">\n      <i class=\"icon-more\" aria-hidden=\"true\"></i>\n      <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "courses.roster.roster_user.manage_user", "Manage %{name}", options) : helperMissing.call(depth0, "t", "courses.roster.roster_user.manage_user", "Manage %{name}", options)))
    + "</span></a>\n    <ul class=\"al-options\">\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canManage), {hash:{},inverse:self.noop,fn:self.program(30, program30, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      <li><a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"><i class=\"icon-user\" aria-hidden=\"true\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "courses.roster.roster_user.links.user_details", "User Details", options) : helperMissing.call(depth0, "t", "courses.roster.roster_user.links.user_details", "User Details", options)))
    + "</a></li>\n\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canRemoveUsers), {hash:{},inverse:self.noop,fn:self.program(39, program39, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.customLinks), {hash:{},inverse:self.noop,fn:self.program(44, program44, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </ul>\n  </div>\n  ";
  return buffer;
  }
function program30(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canResendInvitation), {hash:{},inverse:self.noop,fn:self.program(31, program31, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canLinkStudents), {hash:{},inverse:self.noop,fn:self.program(33, program33, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canEditSections), {hash:{},inverse:self.noop,fn:self.program(35, program35, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canEditRoles), {hash:{},inverse:self.noop,fn:self.program(37, program37, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  return buffer;
  }
function program31(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <li><a href=\"#\" data-event=\"resendInvitation\"><i class=\"icon-email\" aria-hidden=\"true\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "courses.roster.roster_user.links.resend_invitation", "Resend Invitation", options) : helperMissing.call(depth0, "t", "courses.roster.roster_user.links.resend_invitation", "Resend Invitation", options)))
    + "</a></li>\n      ";
  return buffer;
  }

function program33(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <li><a href=\"#\" data-event=\"linkToStudents\"><i class=\"icon-link\" aria-hidden=\"true\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "courses.roster.roster_user.links.link_to_students", "Link to Students", options) : helperMissing.call(depth0, "t", "courses.roster.roster_user.links.link_to_students", "Link to Students", options)))
    + "</a></li>\n      ";
  return buffer;
  }

function program35(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <li><a href=\"#\" data-event=\"editSections\"><i class=\"icon-edit\" aria-hidden=\"true\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "courses.roster.roster_user.links.edit_sections", "Edit Sections", options) : helperMissing.call(depth0, "t", "courses.roster.roster_user.links.edit_sections", "Edit Sections", options)))
    + "</a></li>\n      ";
  return buffer;
  }

function program37(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <li><a href=\"#\" data-event=\"editRoles\"><i class=\"icon-edit\" aria-hidden=\"true\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "edit_role_1e96ad20", "Edit Role", options) : helperMissing.call(depth0, "t", "edit_role_1e96ad20", "Edit Role", options)))
    + "</a></li>\n      ";
  return buffer;
  }

function program39(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <li style=\"clear: left; border: none;\" aria-hidden=\"true\">\n        <hr />\n      </li>\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isInactive), {hash:{},inverse:self.program(42, program42, data),fn:self.program(40, program40, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      <li><a href=\"#\" data-event=\"removeFromCourse\"><i class=\"icon-trash\" aria-hidden=\"true\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "courses.roster.roster_user.links.remove_from_course", "Remove From Course", options) : helperMissing.call(depth0, "t", "courses.roster.roster_user.links.remove_from_course", "Remove From Course", options)))
    + "</a></li>\n      ";
  return buffer;
  }
function program40(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <li><a href=\"#\" data-event=\"reactivateUser\"><i class=\"icon-user\" aria-hidden=\"true\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "re_activate_user_f7d77c9a", "Re-activate User", options) : helperMissing.call(depth0, "t", "re_activate_user_f7d77c9a", "Re-activate User", options)))
    + "</a></li>\n      ";
  return buffer;
  }

function program42(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <li><a href=\"#\" data-event=\"deactivateUser\"><i class=\"icon-deactivate-user\" aria-hidden=\"true\"></i>\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "deactivate_user_86c09036", "Deactivate User", options) : helperMissing.call(depth0, "t", "deactivate_user_86c09036", "Deactivate User", options)))
    + "</a></li>\n      ";
  return buffer;
  }

function program44(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n      <li><a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"><i class=\"";
  if (helper = helpers.icon_class) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.icon_class); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></i> ";
  if (helper = helpers.text) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.text); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a></li>\n      ";
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canManageDifferentiationTags), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n<td class=\"center\">\n  <div id=";
  if (helper = helpers.avatarId) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.avatarId); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "></div>\n<td>\n  <a href=\"";
  if (helper = helpers.html_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.html_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-student_id=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-course_id=\"";
  if (helper = helpers.course_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.course_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n    class=\"roster_user_name student_context_card_trigger\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1);
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.pronouns), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </a>\n    ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.has_non_collaborative_groups), ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.allow_assign_to_differentiation_tags), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.has_non_collaborative_groups), ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.allow_assign_to_differentiation_tags), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isPending), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isInactive), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  \n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.temporaryEnrollmentLabel), {hash:{},inverse:self.noop,fn:self.program(13, program13, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canViewLoginIdColumn), {hash:{},inverse:self.noop,fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canViewSisIdColumn), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.hideSectionsOnCourseUsersPage), {hash:{},inverse:self.noop,fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n<td>\n  ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.enrollments), {hash:{},inverse:self.noop,fn:self.program(24, program24, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>\n";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.read_reports), {hash:{},inverse:self.noop,fn:self.program(26, program26, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n<td class=\"right\">\n  ";
  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.noop,fn:self.program(29, program29, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.canManage), (depth0 && depth0.canRemoveUsers), options) : helperMissing.call(depth0, "ifAny", (depth0 && depth0.canManage), (depth0 && depth0.canRemoveUsers), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  